import { NotFoundView } from '@/components/NotFoundView.tsx';

/** The bare domain lists nothing: each studio is reached only through its own link. */
export function NoTenantPage() {
  return <NotFoundView title="Откройте ссылку на ваш салон или студию" description="Адрес выглядит так: /s/название-студии/" />;
}
